module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/FJABJ6/tc-custom/9780795319587.jpg?1728259292097",
      "alt": "This image is the cover for the book Maggie, The Ladies In Love Series"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Maggie, The Ladies In Love Series\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A tragic past taints one woman’s future in this intriguing Regency romance from the "), _c('i', [_vm._v("New York Times")]), _vm._v("–bestselling author of the Agatha Raisin mysteries.")]), _c('br'), _c('br'), _vm._v("Maggie Macleod was weary of life with a soul sickness that ate into every fiber of her being. In a mad way, it did not seem strange to her that she should be on her way to the high court to stand trial for the murder of her husband. Her marriage seemed to have been one long, dreary desert lit by flares of cruelty. But Maggie is innocent in the matter of her beastly husband’s death, and she resolves to answer the question that plagues her: Who "), _c('i', [_vm._v("did")]), _vm._v(" murder the man?"), _c('br'), _c('br'), _c('b', [_vm._v("Praise for M.C. Beaton ")]), _c('br'), _c('br'), _vm._v("“A romance writer who deftly blends humor and adventure . . . [sustaining] her devoted audience to the last gasp.” —"), _c('i', [_vm._v("Booklist")]), _c('br'), _c('br'), _vm._v("“Veteran author Marion Chesney (aka M.C. Beaton) delivers top-notch Regency fare.” —"), _c('i', [_vm._v("RT Book Reviews")])])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      M. C. Beaton\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    RosettaBooks, LLC\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0